import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import {
    FILE_OPTIONS_DELETE_ICON_CLASSES,
    FILE_OPTIONS_DELETE_TRANSLATE_KEY,
    FILE_OPTIONS_DOWNLOAD_ICON_CLASSES,
    FILE_OPTIONS_DOWNLOAD_TRANSLATE_KEY,
    FILE_OPTIONS_EDIT_ICON_CLASSES,
    FILE_OPTIONS_EDIT_TRANSLATE_KEY,
    FILE_OPTIONS_TRANSLATE_BASE,
    FILE_TYPE_DEFAULT_ICON_CLASS,
    FILE_TYPE_PICTURE_ICON_CLASS,
    FILE_TYPE_VIDEO_ICON_CLASS,
    GENERIC_CATEGORY_LIST_TRANSLATE_BASE,
} from "@shared/constants/stored-documents.constants";
import { StoredDocument } from "@shared/models/stored-document.model";
import { MenuItem } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { MenuModule } from "primeng/menu";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-stored-documents-list-item",
  standalone: true,
  imports: [ButtonModule, CommonModule, MenuModule, TranslateModule],
  templateUrl: "./stored-documents-list-item.component.html",
  styleUrl: "./stored-documents-list-item.component.scss",
})
export class StoredDocumentsListItemComponent implements OnInit, OnDestroy {
  @Input() document: StoredDocument | undefined = undefined;
  @Output() downloadAction = new EventEmitter<StoredDocument>();
  @Output() editAction = new EventEmitter<StoredDocument>();
  @Output() deleteAction = new EventEmitter<StoredDocument>();

  constructor(private translate: TranslateService) {}

  downloadMenuOptionLabel: string | undefined;
  editMenuOptionLabel: string | undefined;
  deleteMenuOptionLabel: string | undefined;

  readonly unsubscribe$ = new Subject<void>();

  ngOnInit() {
    this.translate
      .get(FILE_OPTIONS_TRANSLATE_BASE + FILE_OPTIONS_DOWNLOAD_TRANSLATE_KEY)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: string) => (this.downloadMenuOptionLabel = res));
    this.translate
      .get(FILE_OPTIONS_TRANSLATE_BASE + FILE_OPTIONS_EDIT_TRANSLATE_KEY)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: string) => (this.editMenuOptionLabel = res));
    this.translate
      .get(FILE_OPTIONS_TRANSLATE_BASE + FILE_OPTIONS_DELETE_TRANSLATE_KEY)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: string) => (this.deleteMenuOptionLabel = res));
  }

  ngOnDestroy() {
    // Unsubscribe all
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  get documentIcon() {
    switch (this.document?.idCategory) {
      case 2:
        return FILE_TYPE_PICTURE_ICON_CLASS;
      case 3:
        return FILE_TYPE_VIDEO_ICON_CLASS;
      default:
        return FILE_TYPE_DEFAULT_ICON_CLASS;
    }
  }

  get menuItems(): MenuItem[] {
    return [
      {
        label: this.downloadMenuOptionLabel,
        icon: FILE_OPTIONS_DOWNLOAD_ICON_CLASSES,
        command: () => this.downloadAction.emit(this.document),
      },
      {
        label: this.editMenuOptionLabel,
        icon: FILE_OPTIONS_EDIT_ICON_CLASSES,
        command: () => this.editAction.emit(this.document),
      },
      {
        label: this.deleteMenuOptionLabel,
        icon: FILE_OPTIONS_DELETE_ICON_CLASSES,
        command: () => this.deleteAction.emit(this.document),
      },
    ];
  }

  getGenericCategoryTranslationUri(id: string) {
    return GENERIC_CATEGORY_LIST_TRANSLATE_BASE + id;
  }
}
